skrilla.controller('matchPlaceholderDetailsCtrl', function ($scope, searchService, $stateParams, cacheService, modalService, srefService) {
    $scope.sport = $stateParams.sport;
    cacheService.registerObject("contestSport", $scope.sport);

    $scope.types = [
        "QUARTER_FINAL",
        "SEMI_FINAL",
        "GRAND_FINAL",
        "DEFAULT"
    ];

    searchService.get($scope.sport + "/matches/placeholders/" + $stateParams.id).then(function(response){
        $scope.placeholder = response.data;
    });

    $scope.save = function(){
        $scope.placeholder.originMatch1Id = getId($scope.placeholder.originMatch1)
        $scope.placeholder.originMatch2Id = getId($scope.placeholder.originMatch2)
        $scope.placeholder.originPlaceholder1Id = getId($scope.placeholder.originPlaceholder1)
        $scope.placeholder.originPlaceholder2Id = getId($scope.placeholder.originPlaceholder2)
        $scope.placeholder.matchId = getId($scope.placeholder.match)
        searchService.put($scope.sport + "/matches/placeholders/" + $stateParams.id, $scope.placeholder, "Placeholder successfully updated!").then(function(response){
            if($scope.matchId != null && $scope.placeholder.matchId != undefined){
                console.log($scope.matchId)
                $scope.placeholder.isResolved = true;
            }
        });
    }


    $scope.selectMatch = function(match){
        cacheService.registerObject("matchesModalFunction", function(season, _match){
            cacheService.registerObject("selectedMatch", _match);
            modalService.dismissAll();
        }, true);
        modalService.openModal('/views/matchesModal/matchesModal.html', true, 'lg', true, true, function(){
            $scope.placeholder[match] = cacheService.getObject("selectedMatch");
        });

    }

    $scope.selectPlaceholder = function(placeholder){
        cacheService.registerObject("matchPlaceholdersFunction", function(_placeholder){
            cacheService.registerObject("selectedMatchPlaceholder", _placeholder);
            modalService.dismissAll();
        }, true);
        modalService.openModal('/views/matchPlaceholdersModal/matchPlaceholdersModal.html', true, 'lg', true, true, function(){
            $scope.placeholder[placeholder] = cacheService.getObject("selectedMatchPlaceholder");
            console.log($scope.placeholder[placeholder]);
        });
    }

    $scope.getMatchTitle = function(match){
        if(match){
            return match.teams[0].franchiseName + " v " + match.teams[1].franchiseName;
        }
        else{
            return "No Match"
        }
    }

    $scope.routeToMatch = function(matchId){
        var data = {id: matchId};
        switch($scope.sport){
            case "csgo":
                srefService.go("csgoMatchDetails", data);
                break;
            case "lol":
                srefService.go("lolMatchDetails", data);
                break;
        }
    }

    function getId(obj){
        return obj !== undefined && obj !== null ? obj.id : null;
    }

});